import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import Chevron from '../img/components/Chevron';

const Breadcrumbs = ({
  ariaLabel,
  baseUrl,
  checkoutToken = null,
  screen = 'contact',
  screens,
  status = 'PENDING',
}) => {
  const screenIndex = screens.findIndex((screenObj) => screenObj.path === screen);
  return (
    <nav className="breadcrumb-navigation" aria-label={ariaLabel}>
      {screens.map((scr, index) => {
        const path = checkoutToken ? `${baseUrl}/${checkoutToken}/${scr.path}` : `${baseUrl}/${scr.path}`;
        return (
          <span key={scr.path} className="breadcrumb-navigation__item">
            {(() => {
              if (index === screenIndex) {
                return <strong>{scr.name}</strong>;
              }
              if (index < screenIndex || status === 'PAID') {
                return <Link to={path}>{scr.name}</Link>;
              }
              return scr.name;
            })()}
            {index < screens.length - 1 && <span className="breadcrumb-navigation__chevron"><Chevron /></span>}
          </span>
        );
      })}
    </nav>
  );
};

Breadcrumbs.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  baseUrl: PropTypes.string.isRequired,
  checkoutToken: PropTypes.string,
  screen: PropTypes.string,
  screens: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    }),
  ).isRequired,
  status: PropTypes.string,
};

export default Breadcrumbs;
